<template>
  <div>
    Hi, I'm Erkan, a full stack developer with a focus on Django.
    I specialize in building powerful backends and sleek frontends. Let's turn ideas into code. Ready to create something awesome?
  </div>
</template>
